import BellCurve from './BellCurve.vue';
import Calculator from './Calculator.vue';
import Distance from './Distance.vue';
import Gallery from './Gallery.vue';
import MovingDetails from './MovingDetails.vue';
import Option from './Option.vue';
import Packing from './Packing.vue';
import ScheduleMove from './ScheduleMove.vue';
import Size from './Size.vue';
import Step from './Step.vue';
import Thanks from './Thanks.vue';
import Walkthrough from './Walkthrough.vue';
import Wizard from './Wizard.vue';
import LocalEstimation from './LocalEstimation.vue';
import LocalEstimationBoxes from './LocalEstimationBoxes.vue';
import LocalEstimationHours from './LocalEstimationHours.vue';
import Review from './Review.vue';

export {
  BellCurve,
  Calculator,
  Distance,
  Gallery,
  MovingDetails,
  Option,
  Packing,
  ScheduleMove,
  Size,
  Step,
  Thanks,
  Walkthrough,
  Wizard,
  LocalEstimation,
  LocalEstimationBoxes,
  LocalEstimationHours,
  Review
};
